import { IQuoteItemDetailsForQuoteManagement, IToolSearchResult } from 'types/quoteEditor.types';
import DeviceDescriptionFromClientRequest from './DeviceDescriptionFromClientRequest/DeviceDescriptionFromClientRequest';
import DeviceDescriptionFromCatalog from './DeviceDescriptionFromCatalog/DeviceDescriptionFromCatalog';
import './DeviceDescription.scss';

/** Mapa de claves del backend a etiquetas legibles para las specs dinámicas. */
export const SPEC_LABEL_MAP: Record<string, string> = {
  processor: 'Procesador',
  ram: 'RAM',
  harddrive: 'Almacenamiento',
  displayinches: 'Pantalla',
  resolution: 'Resolución',
  pixels: 'Píxeles',
  fps: 'Frecuencia',
  weight: 'Peso',
  width: 'Ancho',
  height: 'Alto',
  depth: 'Profundidad',
  color: 'Color',
  material: 'Material',
  software: 'Sistema operativo',
  accessories: 'Accesorios',
  inboxaccessories: 'Accesorios en caja'
};

/** Resuelve la etiqueta de display para una clave dinámica del backend. */
export const resolveSpecLabel = (key: string): string => SPEC_LABEL_MAP[key.toLowerCase().trim()] ?? key;

interface IDeviceDescriptionWithItem {
  item: IQuoteItemDetailsForQuoteManagement;
  toolResult?: never;
}

interface IDeviceDescriptionWithTool {
  toolResult: IToolSearchResult;
  item?: never;
}

type IDeviceDescription = IDeviceDescriptionWithItem | IDeviceDescriptionWithTool;

/**
 * Orquestador de descripción de dispositivo. Delega el renderizado según el origen de los datos:
 * - `item`: especificaciones de la solicitud del cliente (DeviceDescriptionFromClientRequest).
 * - `toolResult`: especificaciones del producto del catálogo (DeviceDescriptionFromCatalog).
 */
const DeviceDescription = ({ item, toolResult }: IDeviceDescription) => {
  if (toolResult) return <DeviceDescriptionFromCatalog tool={toolResult} />;
  return <DeviceDescriptionFromClientRequest item={item!} />;
};

export default DeviceDescription;
